// 小豆苗环境的sdk请求相关接口  以及相关的一些逻辑
import router from '@router/index.js';
import store from '@/store';
import {SenderEventTrack} from '@threegene/track';
// 用户调研工具
import {urtLogin} from '@js/util/urt/index';

const xdm = {
  // 获取 token
  getUserInfo() {
    let timeCount = 50;
    let postCount = 0;
    let timer = null;

    function loop(reject) {
      postCount++;
      if (postCount < 3) {
        getUserInfo();
      } else {
        postCount = 0;
        reject('-12'); // 调用xdm.getUserInfo接口失败
      }
    }
    function getUserInfo(resolve, reject) {
      try {
        window.xdm.getUserInfo('', function (data) {
          data = JSON.parse(data);
          if (data && data.token) {
            postCount = 0;
            resolve(data);
          } else {
            loop(reject);
          }
        });
      } catch (e) {
        console.log(e);
        loop(reject);
      }
    }
    return new Promise((resolve, reject) => {
      if (window.xdm) {
        getUserInfo(resolve, reject);
      } else {
        timer = setInterval(function () {
          timeCount += 50;
          // 在3秒内轮，每隔50毫秒检测一次window是否注册xdm,检测到了清除计时器，超过3秒也清除计时器
          if (timeCount > 5000) {
            timeCount = 50;
            clearInterval(timer);
            reject('-13'); // window.xdm对象注册失败
          } else {
            if (window.xdm) {
              getUserInfo(resolve, reject);
              timeCount = 50;
              clearInterval(timer);
            }
          }
        }, timeCount);
      }
    });
  },
  // 获取token  保存token
  async login() {
    let userInfo;
    try {
      userInfo = await xdm.getUserInfo();
    } catch (e) {
      router.push({name: 'error', params: {code: e}});
    }
    if (!userInfo) {
      router.push({name: 'error', params: {text: '获取token为空'}});
    }
    const {token, ...rest} = userInfo;
    // 登录成功保存登录状态
    store.commit('global/SET_TOKEN', token);
    store.commit('global/SET_USERINFO', rest);
    SenderEventTrack.login(rest.userId);
    // 登录
    urtLogin(rest.userId);
  },
  // 禁止分享
  forbidShare(isShow, failFn) {
    function showShareBtn() {
      try {
        const params = JSON.stringify({show: isShow});
        window.xdm.showShareBtn(params, function () {});
      } catch (e) {
        failFn && failFn(e);
      }
    }
    if (window.xdm) {
      showShareBtn();
    } else {
      const timer = setTimeout(function () {
        showShareBtn();
        clearTimeout(timer);
      }, 500);
    }
  },
  setTitle(params) {
    if (!params) params = {title: '小豆苗', color: '#ffffff'};
    function setTitleBar() {
      try {
        params = JSON.stringify(params);
        window.xdm.setTitleBar(params, function (data) {});
      } catch (e) {
        console.log(e);
      }
    }
    if (window.xdm) {
      setTitleBar();
    } else {
      setTimeout(function () {
        setTitleBar();
      }, 500);
    }
  }
};

export {xdm};



// WEBPACK FOOTER //
// ./src/js/native/xdmApi.js